window.SiteReady(($) => {
  console.log('Init Block: Features');

  // let $items = $('.js-features');

  // $items.each((index, el) => {
  //   let $item = $(el);
  //   let $splide = $item.find('.js-splide');
  // });

  // Testing Watercolor animation
  // $("#group_anchor-2").checkpoint();

});